// src/pages/Offers.js
import React, { useEffect, useState } from "react";
import { Table, Button, message } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import OfferForm from "./OffersForm";
import API from "../../api";
import CustomTable from "../../components/Table/CustomTable";
import ConfirmationModal from "../../components/ConfirmationModal";

export default function Offers() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [offers, setOffers] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [offerToDelete, setOfferToDelete] = useState(null);
  const [paginationInfo, setPaginationInfo] = useState({ currentPage: 1, pageSize: 5 });

  const getOffers = async () => {
    try {
      const response = await API.get("/offers");
      setOffers(response?.data);
    } catch (err) {
      console.error("Error fetching offers:", err);
    }
  };

  useEffect(() => {
    getOffers();
  }, []);

  const handleEditClick = (offer) => {
    setIsEdit(true);
    setSelectedOffer({ ...offer });
    setOpenDrawer(true);
  };

  const handleAddOrEditOffer = async (offerData) => {
    try {
      if (isEdit) {
        const res = await API.put(`/offers/${selectedOffer?._id}`, offerData);
        if (res.status === 200) {
          message.success("Offer updated successfully!");
        }
      } else {
        const res = await API.post("/offers", offerData);
        if (res.status === 200) {
          message.success("Offer added successfully!");
        }
      }
      getOffers();
      setOpenDrawer(false);
    } catch (error) {
      console.error("Error saving offer:", error);
      message.error(error.response?.data?.message);
    }
  };

  const handleDeleteOffer = async () => {
    try {
      await API.delete(`/offers/${offerToDelete?._id}`);
      setOffers(offers.filter((offer) => offer?._id !== offerToDelete?._id));
      setIsDeleteModalVisible(false);
      message.success("Offer deleted successfully!");
    } catch (err) {
      console.error("Error deleting offer:", err);
      message.error(err.response?.data?.message);
    }
  };

  const columns = [
    { title: "Index", key: "index",  render: (_, __, index) =>
      (paginationInfo.currentPage - 1) * paginationInfo.pageSize + index + 1,},
    { title: "Offer Type", dataIndex: "offerType", key: "offerType" },
    { title: "Bank Name", dataIndex: "bankName", key: "bankName" },
    { title: "Offer Details", dataIndex: "offerDetails", key: "offerDetails" },
    { title: "Valid From", dataIndex: "validFrom", key: "validFrom" },
    { title: "Valid Until", dataIndex: "validUntil", key: "validUntil" },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <div>
          <Button icon={<EditOutlined />} onClick={() => handleEditClick(record)} />
          <Button
            icon={<DeleteOutlined />}
            danger
            style={{ marginLeft: 8 }}
            onClick={() => {
              setOfferToDelete(record);
              setIsDeleteModalVisible(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => [setOpenDrawer(true), setIsEdit(false)]}
        >
          Add Offer
        </Button>
      </div>

      {openDrawer && (
        <OfferForm
          open={openDrawer}
          setOpen={setOpenDrawer}
          isEdit={isEdit}
          initialValue={isEdit ? selectedOffer : null}
          onSubmit={handleAddOrEditOffer}
        />
      )}

      <CustomTable columns={columns} dataSource={offers}   onPaginationChange={(pagination) =>
          setPaginationInfo({ currentPage: pagination.current, pageSize: pagination.pageSize })
      }/>

      <ConfirmationModal
        visible={isDeleteModalVisible}
        onConfirm={handleDeleteOffer}
        onCancel={() => setIsDeleteModalVisible(false)}
        title="Confirm Deletion"
        content="Are you sure you want to delete this offer? This action cannot be undone."
      />
    </div>
  );
}
